import React from 'react'
import PropTypes from 'prop-types'
import {
    Link
} from 'react-router-dom';
export default function Navbar(props) {

    return (
        <div>
            <nav
                className="container">
                <ul>
                    <li className='nav-items'><Link to="/mammas_cafe/">{props.title}</Link></li>
                    <li className='nav-items'><Link to="/mammas_cafe/menu">{props.menu}</Link></li>
                    {/* <li className='nav-items'>{props.title}</li> */}
                    {/* <li className='nav-items'><Link to="/">{props.home}</Link></li> */}
                    {/* <li className='nav-items'>{props.home}</li> */}
                    <li className='nav-items'><Link to="/mammas_cafe/about">{props.about}</Link></li>
                    {/* <li className='nav-items'>{props.about}</li> */}
                    {/* <li className='nav-items'><Link to="/contact">{props.contact}</Link></li>  */}
                    {/* <li className='nav-items'>{props.contact}</li>  */}
                </ul>
            </nav>
        </div>
    )
}
Navbar.propTypes = {
    title: PropTypes.string.isRequired,
    // home:PropTypes.string.isRequired,
    contact: PropTypes.string,
    about: PropTypes.string,
}
Navbar.defaultProps = {
    title: 'Title Here',
    // home:'Home here',
    contact: 'contact here',
    about: 'about here',
}